import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import cx from 'classnames'
import { screenSizes } from 'constants/global'
import { FormattedMessage } from 'locales/index'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { Button, AppButtonProps } from '@commutifi-fe/ui'
import { Overwrite } from 'utility-types'
import styles from './styles.module.scss'

function SmallScreenButton({
  startSurveyBtnText,
  redirectToLogin,
  onClick,
  ...props
}: Overwrite<AppButtonProps, { onClick?: React.MouseEventHandler<HTMLElement> }> &
  Pick<StartSurveyButtonProps, 'startSurveyBtnText' | 'redirectToLogin'>) {
  return (
    <div className={cx(styles['button-container'], styles['button-container--fixed'], 'u-color--neutral-600')}>
      {onClick || (!onClick && redirectToLogin) ? (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Consider refactor
        <div className="u-flex-1 u-flex-space-between u-flex-align-center" onClick={onClick || redirectToLogin}>
          {!onClick ? (
            <FormattedMessage id="signup.account.buttons.alreadyHaveAnAccount" />
          ) : (
            startSurveyBtnText || (
              <span className="u-flex-1 u-margin-right--medium">
                <FormattedMessage id="intro.button.getScore" />
              </span>
            )
          )}
          <Button
            shape="circle"
            style={{
              padding: 0,
              boxShadow: 'none',
              borderColor: styles.carbonColor,
              borderWidth: '2px',
              height: styles.circleButtonWidth,
              width: styles.circleButtonWidth
            }}
            {...props}
          >
            <FontAwesomeIcon size="lg" icon={faArrowRight} className="u-color--neutral-600" />
          </Button>
        </div>
      ) : null}
      {redirectToLogin && onClick ? <AccountAlreadyExistButton onClick={redirectToLogin} size="small" /> : null}
    </div>
  )
}

interface StartSurveyButtonProps {
  className?: string
  /**
   * If this prop is passed we will add a button to start the survey
   * that will call this callback function onClick
   */
  startSurvey?: AppButtonProps['onClick']
  startSurveyBtnText?: React.ReactNode
  /**
   * If this prop is defined we will add a button 'I already have an account'
   * that will call this callback function onClick
   */
  redirectToLogin: React.MouseEventHandler<HTMLElement> | undefined
}

export function StartSurveyButtons({
  className,
  startSurvey,
  startSurveyBtnText,
  redirectToLogin
}: StartSurveyButtonProps) {
  const isXSmall = useMediaQuery({ maxWidth: screenSizes.xsMaxWidth })
  return isXSmall ? (
    <SmallScreenButton
      onClick={startSurvey}
      startSurveyBtnText={startSurveyBtnText}
      redirectToLogin={redirectToLogin}
    />
  ) : (
    <div className={cx(styles['button-container'], className)}>
      {redirectToLogin ? <AccountAlreadyExistButton onClick={redirectToLogin} /> : <div />}
      {startSurvey ? (
        <Button type="primary" onClick={startSurvey}>
          <span>
            {startSurveyBtnText || <FormattedMessage id="intro.button.getScore" />}
            <FontAwesomeIcon className="u-margin-left--small" icon={faArrowRight} />
          </span>
        </Button>
      ) : (
        <div />
      )}
    </div>
  )
}

function AccountAlreadyExistButton({ style, ...props }: React.ComponentProps<typeof Button>) {
  return (
    <Button type="link" style={{ paddingLeft: 0, alignSelf: 'flex-start', ...style }} {...props}>
      <FormattedMessage id="signup.account.buttons.alreadyHaveAnAccount" />
    </Button>
  )
}
StartSurveyButtons.AccountAlreadyExist = AccountAlreadyExistButton
